import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import analytics from './services/analytics';

// Defer analytics initialization until after paint
const initAnalytics = () => analytics.init();
if ('requestIdleCallback' in window) {
  requestIdleCallback(initAnalytics);
} else {
  setTimeout(initAnalytics, 0);
}

createRoot(document.getElementById("root")!).render(<App />);
